import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UploadContext } from "@air/component-upload-dropzone";
import { ContentCollectionOnboardingCard } from "@air/feature-content-collection/ui";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { contentCollectionFormSelector } from "../redux";
import { ContentCollectionBackground } from "./ContentCollectionBackground";
export const ContentCollectionOnboardingView = ()=>{
    const form = useSelector(contentCollectionFormSelector);
    const { openUploader } = useContext(UploadContext);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative z-0 flex h-full grow items-end justify-center overflow-y-auto bg-grey-3 pt-8 md:py-8",
        children: [
            /*#__PURE__*/ _jsx(ContentCollectionBackground, {
                className: "absolute inset-x-0 top-20 -z-1 w-[150%] -translate-x-1/4 md:top-0 md:w-full md:translate-x-0"
            }),
            /*#__PURE__*/ _jsx(ContentCollectionOnboardingCard, {
                description: form === null || form === void 0 ? void 0 : form.description,
                onUpload: openUploader,
                title: (form === null || form === void 0 ? void 0 : form.title) || ""
            })
        ]
    });
};
ContentCollectionOnboardingView.displayName = "ContentCollectionOnboardingView";
